module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kUyu1"))).then(() => parcelRequire('hEqeo'));